import { Injectable } from '@angular/core';
import { Observable, of } from "rxjs";

import {
    ProcessReportResourceService
} from "app_sasha/shared/resources/process-report/process-report-resource.service";
import { IProcessReportSearchParams } from "app_sasha/pages/process-report/process-report-page.component";
import { QueryParamsMappingService } from "app_sasha/pages/process-report/query-params-mapping.service";
import { IPaginationRecordset } from "libraries/component/pagination/IPagination";
import _cloneDeep from "lodash-es/cloneDeep";
import { EProcessReportStatus, IProcessReportResponse } from "libraries/interfaces/process-report/i-process-report-response";

@Injectable()
export class ProcessReportDomainService {


    constructor(
        private readonly processReportResourceService: ProcessReportResourceService,
        private readonly queryParamsMappingService: QueryParamsMappingService,
    ) {
    }

    public search(requestArg: IProcessReportSearchParams): Observable<IProcessReportResponse> {
        //temp fix #32563
        const request: IProcessReportSearchParams = _cloneDeep(requestArg);
        if (!request.st) {
            request.st = [];
        }

        let recordset: IPaginationRecordset = {
            count: request.pcount ?? 50,
        };

        if (request.pprev) {
            recordset = {
                searchPrevContextId: Number(request.pprev),
                count: Number(request.pcount)
            };
        } else if (request.pnext) {
            recordset = {
                searchNextContextId: Number(request.pnext),
                count: Number(request.pcount)
            };
        }

        return this.processReportResourceService
            .searchProcess(
                this.queryParamsMappingService.mapUrlToApi(request, recordset)
            );
    }

}
